import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '../Buttons/TextButton';
import Plus from '../Icons/Plus';
import Check from '../Icons/Check';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import GhostButton from '../Buttons/GhostButton';
import { useThrottle } from '../utils/hooks/useThrottle';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './JoinGroupButton.scss';
var JoinGroupButton = function (_a) {
    var _b;
    var group = _a.group, requestJoin = _a.requestJoin, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    // throttle those button presses so there's time for any notifications to disappear/backend requests to complete
    var requestJoinThrottled = useThrottle(function () { return requestJoin(group); }, [requestJoin, group], 6000);
    if ((_b = group.extendedGroup) === null || _b === void 0 ? void 0 : _b.isIngroup) {
        return (React.createElement(TextButton, { size: "small", variant: "unbranded", className: classnames(s['root'], className), icon: Check, iconClassName: s['check-icon'], disabled: true }, t('joinGroupButton.member')));
    }
    if (isMobile) {
        return (React.createElement(GhostButton, { size: "small", variant: "approval-green", className: classnames(s['root'], className), onClick: requestJoinThrottled, biData: { evid: BiEventType.JOIN_GROUP, groupid: group.useridUuid } }, t('joinGroupButton.join')));
    }
    else {
        return (React.createElement(TextButton, { size: "small", variant: "approval-green", className: classnames(s['root'], className), onClick: requestJoinThrottled, icon: Plus, iconClassName: s['plus-icon'], biData: { evid: BiEventType.JOIN_GROUP, groupid: group.useridUuid } }, t('joinGroupButton.join')));
    }
};
JoinGroupButton.displayName = 'JoinGroupButton';
export default JoinGroupButton;
//# sourceMappingURL=JoinGroupButton.js.map